/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ItauAtualizacaoCobrancaRecorrente } from './itauAtualizacaoCobrancaRecorrente';
import { ItauCobrancaRecorrenteCalendario } from './itauCobrancaRecorrenteCalendario';
import { ItauDevedorCobrancaRecorrente } from './itauDevedorCobrancaRecorrente';
import { ItauRecebedorCobrancaRecorrente } from './itauRecebedorCobrancaRecorrente';
import { ItauTentativaCobrancaRecorrente } from './itauTentativaCobrancaRecorrente';
import { ItauValorCobranca } from './itauValorCobranca';

export interface ItauCobrancaRecorrenteResponse {
  ajusteDiaUtil?: boolean;
  atualizacao?: Array<ItauAtualizacaoCobrancaRecorrente>;
  calendario?: ItauCobrancaRecorrenteCalendario;
  devedor?: ItauDevedorCobrancaRecorrente;
  idRec?: string;
  infoAdicional?: string;
  politicaRetentativa?: ItauCobrancaRecorrenteResponse.PoliticaRetentativaEnum;
  recebedor?: ItauRecebedorCobrancaRecorrente;
  status?: ItauCobrancaRecorrenteResponse.StatusEnum;
  tentativas?: Array<ItauTentativaCobrancaRecorrente>;
  txid?: string;
  valor?: ItauValorCobranca;
}
export namespace ItauCobrancaRecorrenteResponse {
  export type StatusEnum =
    | 'CRIADA'
    | 'ATIVA'
    | 'CONCLUIDA'
    | 'EXPIRADA'
    | 'REJEITADA'
    | 'CANCELADA';
  export const StatusEnum = {
    CRIADA: 'CRIADA' as StatusEnum,
    ATIVA: 'ATIVA' as StatusEnum,
    CONCLUIDA: 'CONCLUIDA' as StatusEnum,
    EXPIRADA: 'EXPIRADA' as StatusEnum,
    REJEITADA: 'REJEITADA' as StatusEnum,
    CANCELADA: 'CANCELADA' as StatusEnum
  };
  export type PoliticaRetentativaEnum = 'NAO_PERMITE' | 'PERMITE_3R_7D';
  export const PoliticaRetentativaEnum = {
    NAOPERMITE: 'NAO_PERMITE' as PoliticaRetentativaEnum,
    PERMITE3R7D: 'PERMITE_3R_7D' as PoliticaRetentativaEnum
  };
}
